module.exports = __webpack_public_path__ + "static/sport/img-text.8674029.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/img-text.png
// module id = fXlr
// module chunks = 0